var fn = function( obj ){
var __t,__p='';
__p+='#if __VERSION__ == 300\n  #define IN in\n  #define texture2D(a,b) texture( a, b )\n#else\n  #define IN varying\n  #define FragColor gl_FragColor\n#endif\n\n#if __VERSION__ == 300\n  out vec4 FragColor;\n#endif';
return __p;
};
fn.toString=fn;
module.exports = fn;